import React from "react";
import dayjs from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { useState, useEffect } from 'react';
import { all_routes } from "../../../Router/all_routes.jsx";
import { base_api_url } from "../../../environment.jsx";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import PropTypes from 'prop-types';


const AddCategory = ({ show, onClose, editMode = false, CategorieData = null, onFormSubmit }) => {
    const MySwal = withReactContent(Swal);
    const ideresto = JSON.parse(localStorage.getItem("user"))?.restoId;
    const route = all_routes;
    const [loading, setLoading] = useState(false);
    const [typeCategories, setTypeCategories] = useState([]);
    const [loadingTypes, setLoadingTypes] = useState(false);
    const navigate = useNavigate();
    // Animation state for slide-in/slide-out (doit être AVANT tout return ou logique conditionnelle)
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (show) {
            setTimeout(() => setVisible(true), 10);
        } else {
            setVisible(false);
        }
    }, [show]);

    //pour recuprer les elements du formulaire
    const [formData, setFormData] = useState({
        "nom": "",
        "id_restaurant": ideresto,
        "description": "",
        "id_type": null,     
    });

    // Fetch type categories on component mount
    useEffect(() => {
        fetchTypeCategories();
    }, []);

    // Function to fetch type categories
    const fetchTypeCategories = async () => {
        setLoadingTypes(true);
        try {
            const token = JSON.parse(localStorage.getItem("user"))?.access_token;
            const response = await axios.get(`${base_api_url}api/typecategorie`,{
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            console.log("Type categories loaded:", response.data);
            setTypeCategories(response.data || []);
        } catch (error) {
            console.error("Error fetching type categories:", error);
            MySwal.fire({
                icon: "error",
                // title: "Erreur",
                text: "Impossible de charger les types de catégories.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                    customClass: { popup: "pixel-toast" }
});
        } finally {
            setLoadingTypes(false);
        }
    };

     // Use Effect pour populate le formulaire en mode édition
    useEffect(() => {
        if (editMode && CategorieData) {
            console.log("Auto-populating form with category data:", CategorieData);
            setFormData({
                nom: CategorieData.nom || "",
                description: CategorieData.description || "",
                id_type: CategorieData.id_type || null,
                id_restaurant: ideresto,
            });
        } else {
            // Reset form for add mode
            setFormData({
                "nom": "",
                "description": "",
                "id_type": null,
                "id_restaurant": ideresto,
            });
        }
    }, [editMode, CategorieData, ideresto, show]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const resetForm = () => {
        setFormData({
            "nom": "",
            "description": "",
            "id_type": null,
        });
    };

    // pour la soumission du formulaire
    const handleSubmit = async (e) => {
        e.preventDefault(); // éviter le rechargement de la page
        setLoading(true);
        try {
        const token = JSON.parse(localStorage.getItem("user"))?.access_token;
        let response;
        console.log(formData)
        
        // Prepare form data with proper time formatting
        const formDatatoSubmit = {
            ...formData,
        };

        // Remove empty string values and replace with null
        Object.keys(formDatatoSubmit).forEach(key => {
            if (formDatatoSubmit[key] === '') {
                formDatatoSubmit[key] = null;
            }
        });

        if (editMode && CategorieData?.id) {
            response = await axios.put(`${base_api_url}api/categorie/${CategorieData.id}`,   
                formDatatoSubmit, 
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    }
                });
        } else {
            response = await axios.post(`${base_api_url}api/categorie`, 
                formDatatoSubmit,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });
        }

        console.log(response)
        console.log("Réponse API :", response.data);
        

        // Handle successful responses (200, 201)
        if (response.status === 200 || response.status === 201) {
            // Show success toast
            MySwal.fire({
                icon: "success",
                // title: editMode ? "Mise à jour réussie !" : "Enregistrement réussie !",
                text: editMode ? "La catégorie a été modifiée avec succès." : "La catégorie a été créée avec succès.",
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
            
            // Close modal first
            onClose();
            
            // Call onFormSubmit after successful operation
            if (onFormSubmit) {
                onFormSubmit();
            }

            // Navigate only if not in edit mode
            if (!editMode) {
                localStorage.setItem("categorie", JSON.stringify(response.data));
                setTimeout(() => {
                    navigate(route.categorie);
                }, 3000);
            }
        }
        
        } catch (error) {
            console.log("Error details:", error.response?.data || error.message);
            
//             let errorTitle = "Erreur";
            let errorMessage = "Une erreur s'est produite. Veuillez réessayer.";
            
            if (error.response) {
                const status = error.response.status;
                const errorData = error.response.data;
                
                switch (status) {
                    case 400:
//                         errorTitle = "Données invalides";
                        if (errorData?.message?.includes("nom")) {
                            errorMessage = "Le nom de la catégorie est requis et ne peut pas être vide.";
                        } else {
                            errorMessage = errorData?.message || "Les données saisies ne sont pas valides. Vérifiez que tous les champs requis sont remplis correctement.";
                        }
                        break;
                        
                    case 401:
//                         errorTitle = "Accès non autorisé";
                        errorMessage = "Votre session a expiré. Veuillez vous reconnecter pour continuer.";
                        setTimeout(() => {
                            navigate(route.signin);
                        }, 2000);
                        break;
                        
                    case 402:
//                         errorTitle = "Champs requis manquants";
                        if (!formData.nom || formData.nom.trim() === "") {
                            errorMessage = "Le nom de la catégorie est requis.";
                        } else {
                            errorMessage = "Veuillez remplir tous les champs obligatoires.";
                        }
                        break;
                        
                    case 404:
//                         errorTitle = editMode ? "Catégorie introuvable" : "Ressource introuvable";
                        errorMessage = editMode 
                            ? "La catégorie que vous tentez de modifier n'existe plus ou a été supprimée."
                            : "La ressource demandée est introuvable. Veuillez actualiser la page et réessayer.";
                        break;
                        
                    case 409:
//                         errorTitle = "Catégorie déjà existante";
                        errorMessage = "Une catégorie avec ce nom existe déjà. Veuillez choisir un nom différent.";
                        break;
                        
                    case 422:
//                         errorTitle = "Données non valides";
                        errorMessage = errorData?.message || "Les données saisies ne respectent pas le format requis.";
                        break;
                        
                    case 500:
//                         errorTitle = "Erreur du serveur";
                        errorMessage = "Une erreur s'est produite sur le serveur. Veuillez réessayer dans quelques instants.";
                        break;
                        
                    case 503:
//                         errorTitle = "Service temporairement indisponible";
                        errorMessage = "Le service est temporairement indisponible. Veuillez réessayer dans quelques minutes.";
                        break;
                        
                    default:
//                         errorTitle = `Erreur ${status}`;
                        errorMessage = errorData?.message || `Une erreur inattendue s'est produite (Code: ${status}).`;
                }
            } else if (error.request) {
//                 errorTitle = "Problème de connexion";
                errorMessage = "Impossible de contacter le serveur. Vérifiez votre connexion internet et réessayez.";
            }
            
            // Show error toast
            MySwal.fire({
                icon: "error",
                // title: errorTitle,
                text: errorMessage,
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000, // Longer timer for error messages
                timerProgressBar: true,
                customClass: {
                    popup: "pixel-toast",
                },
            });
        } finally {
            setLoading(false);
        }
    };


    // Animation state for slide-in/slide-out (doit être AVANT tout return ou logique conditionnelle)
    // (déjà défini plus haut, donc on ne redéfinit pas ici)

    // Fermer le modal (slide-out)
    const handleClose = () => {
        setVisible(false);
        setTimeout(() => {
            resetForm();
            onClose();
        }, 200); // Durée de l'animation
    };

    if (!show) return null;

    return (
        <div>
            {show && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        right: 0,
                        width: '420px',
                        height: '100vh',
                        background: '#fff',
                        boxShadow: '-2px 0 16px rgba(0,0,0,0.08)',
                        zIndex: 2000,
                        display: 'flex',
                        flexDirection: 'column',
                        borderRadius: '0 0 0 0',
                        transform: visible ? 'translateX(0)' : 'translateX(100%)',
                        transition: 'transform 0.2s cubic-bezier(.4,0,.2,1)',
                    }}
                >
                    <form onSubmit={handleSubmit} style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
                        {/* Header */}
                        <div style={{padding: '32px 32px 0 32px', borderBottom: '1px solid #f2f2f2', display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                            <div>
                                <h2 style={{fontSize: 22, fontWeight: 700, margin: 0}}>{CategorieData ? "Modifier la catégorie" : "Nouvelle catégorie"}</h2>
                            </div>
                            <button
                                type="button"
                                aria-label="Fermer"
                                onClick={handleClose}
                                style={{ background: 'none', border: 'none', fontSize: 28, color: '#888', cursor: 'pointer', marginLeft: 8 }}
                            >
                                ×
                            </button>
                        </div>
                        {/* Body */}
                        <div style={{flex: 1, overflowY: 'auto', padding: '24px 32px 0 32px'}}>
                            {/* Type de catégorie (racine) */}
                            <div style={{marginBottom: 24}}>
                                <label style={{fontWeight: 600, fontSize: 15, marginBottom: 4, display: 'block'}}>Type de catégorie *</label>
                                <select
                                    name="id_type"
                                    value={formData.id_type || ""}
                                    onChange={handleChange}
                                    className="form-control"
                                    disabled={loadingTypes || editMode}
                                    style={{background: editMode ? '#f5f5f5' : '#fff', color: '#222', border: '1px solid #e0e0e0', borderRadius: 8, padding: '10px 12px', fontSize: 15, width: '100%'}}
                                >
                                    <option value="">Sélectionner un type</option>
                                    {typeCategories.map((type) => (
                                        <option key={type.id} value={type.id}>{type.nom}</option>
                                    ))}
                                </select>
                                {editMode && <div style={{color: '#bdbdbd', fontSize: 13, marginTop: 2}}>Le type de catégorie ne peut pas être modifié</div>}
                            </div>
                            {/* Nom */}
                            <div style={{marginBottom: 24}}>
                                <label style={{fontWeight: 600, fontSize: 15, marginBottom: 4, display: 'block'}}>Nom de la catégorie *</label>
                                <input
                                    type="text"
                                    name="nom"
                                    value={formData.nom}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{border: '1px solid #e0e0e0', borderRadius: 8, padding: '10px 12px', fontSize: 15, width: '100%'}}
                                    required
                                />
                            </div>
                            {/* Description */}
                            <div style={{marginBottom: 24}}>
                                <label style={{fontWeight: 600, fontSize: 15, marginBottom: 4, display: 'block'}}>Description (optionnelle)</label>
                                <textarea
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    className="form-control"
                                    style={{border: '1px solid #e0e0e0', borderRadius: 8, padding: '10px 12px', fontSize: 15, width: '100%', minHeight: 48, resize: 'vertical'}}
                                    placeholder="Une courte description de cette catégorie..."
                                />
                            </div>
                        </div>
                        {/* Footer */}
                        <div style={{padding: '24px 32px', borderTop: '1px solid #f2f2f2', background: '#fff', display: 'flex', flexDirection: 'column', gap: 12}}>
                            <button
                                type="submit"
                                disabled={loading}
                                style={{background: '#ff6a3d', color: '#fff', fontWeight: 700, fontSize: 16, border: 'none', borderRadius: 8, padding: '12px 0', marginBottom: 0, cursor: loading ? 'not-allowed' : 'pointer', transition: 'background 0.2s', boxShadow: '0 4px 12px rgba(255, 106, 61, 0.25)'}}
                            >
                                {loading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        {editMode ? "Mise à jour..." : "Création..."}
                                    </>
                                ) : (
                                    editMode ? "Mettre à jour" : "Enregistrer"
                                )}
                            </button>
                            {editMode && (
                                <button
                                    type="button"
                                    style={{background: '#fff', color: '#e53935', border: '1px solid #e53935', fontWeight: 700, fontSize: 16, borderRadius: 8, padding: '12px 0', cursor: 'pointer'}}
                                    onClick={() => {/* TODO: handle delete */}}
                                >
                                    Supprimer cette catégorie
                                </button>
                            )}
                        </div>
                    </form>
                </div>
            )}
            {/* Modal backdrop */}
            {show && (
                <div
                    className="modal-backdrop fade show"
                    style={{ zIndex: 1050 }}
                    onClick={handleClose}
                ></div>
            )}
        </div>
    );
}

AddCategory.propTypes = {
    onFormSubmit: PropTypes.func.isRequired,
    show: PropTypes.bool,
    onClose: PropTypes.func,
    editMode: PropTypes.bool,
    CategorieData: PropTypes.object
};

export default AddCategory;
